import { render, staticRenderFns } from "./PaymentNotVirgin.vue?vue&type=template&id=40c46c6e&scoped=true&"
import script from "./PaymentNotVirgin.vue?vue&type=script&lang=js&"
export * from "./PaymentNotVirgin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c46c6e",
  null
  
)

export default component.exports